<template>
  <div>
    <label class="editor-label" v-if="value">{{ placeholder }}</label>

    <editor
      :value="value"
      @input="onInput"
      :placeholder="placeholder"
      api-key="u5934q5w5s81yyj7imd6h87byzeqk2g4822lwkd4unf4lhkc"
      :init="{
        height,
        width,
        menubar,
        branding,
        statusbar,
        resize,
        plugins,
        skin,
        icons,
        toolbar_location,
        toolbar,
        content_style: '.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {color: rgba(96, 96, 96, 0.87);}'
      }"

    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: () => null,
    },
    placeholder: {
      default: null,
      type: String,
    },
    height: {
      default: 124,
      type: Number,
    },
    width: {
      default: 416,
      type: Number,
    },
    menubar: {
      default: false,
      type: Boolean,
    },
    branding: {
      default: false,
      type: Boolean,
    },
    statusbar: {
      default: false,
      type: Boolean,
    },
    resize: {
      default: true,
      type: Boolean,
    },
    plugins: {
      default: () => ["autolink lists link image anchor textcolor"],
      type: Array,
    },
    skin: {
      default: "naked",
      type: String,
    },
    icons: {
      default: "small",
      type: String,
    },
    toolbar_location: {
      default: "bottom",
      type: String,
    },
    toolbar: {
      default: "bold italic underline forecolor numlist image link",
      type: String,
    },
  },
  created() {
    this.setEditorInput();
  },
  updated() {
    this.setEditorInput();
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    setEditorInput() {
      const iframe = document.querySelector("iframe");
      if (iframe) {
        const ele = iframe?.contentWindow?.document.querySelector("#tinymce p");
        if (this.value && ele) ele.style.transform = "translateY(10px)";        
        // else ele.style.transform = "translateY(0)";
      }
    },
  },
};
</script>

<style scoped>

.editor-label {
  
  color: #103f5e;
  margin-top: 8px;
  margin-inline-end: 0;
  margin-bottom: 0;
  margin-inline-start: 17px;
  z-index: 2;
  font-size: 15px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
  z-index: 99;
}
</style>
